var React = require('react');

function SafeAeroInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40","height":"40","rx":"12","fill":"#E2E6EC","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 29L31 29V31L9 31V29Z","fill":"#333F48","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 13H27V25H22L23 27H29V11H11V18H13V13ZM13 20H11V27H21L20 25H13V20Z","fill":"#333F48","key":2}),React.createElement("circle",{"cx":"20","cy":"19","r":"3","stroke":"#333F48","strokeWidth":"2","key":3}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 20V25H20L21 27H11V20H13Z","fill":"#0253A2","key":4})]);
}

SafeAeroInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = SafeAeroInline;

SafeAeroInline.default = SafeAeroInline;
